import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { masks } from "@core/utils/masks";
import { Agreement } from "@modules/agreements/types/agreement";
import { normalizeVolumetryAgreementFields } from "@modules/agreements/utils/normalizeVolumetryAgreementFields";
import { AgreementFormValues } from "@modules/agreements/validations/agreementSchema";
import { format } from "date-fns";

export async function createAgreementService(
  data: AgreementFormValues
): Promise<Agreement> {
  if (data.start_date) {
    const formattedStartDate =
      typeof data.start_date !== "string"
        ? format(data.start_date, "yyyy-MM-dd")
        : data.start_date;

    data.start_date = formattedStartDate;
  }

  if (data.received_books_start_date) {
    const formattedReceivedBooksStartDate =
      typeof data.received_books_start_date !== "string"
        ? format(data.received_books_start_date, "yyyy-MM-dd")
        : data.received_books_start_date;

    data.received_books_start_date = formattedReceivedBooksStartDate;
  }

  if (data.value) {
    const unmaskedValue = Number(masks.unmask(data.value));
    data.value = (unmaskedValue / 100).toFixed(2);
  }

  if (data.referral_value) {
    const unmaskedReferralValue = Number(masks.unmask(data.referral_value as any));
    (data as any).referral_value = (unmaskedReferralValue / 100).toFixed(2);
  }

  normalizeVolumetryAgreementFields(data);
  if (data.volumetry_email_day == null) {
    delete data.volumetry_email_day;
  }

  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: agreement } = await api.post<Agreement>(
    "v1/agreement_admin/",
    formatedData,
    { headers }
  );

  return agreement;
}
